import { Box, Skeleton } from "@chakra-ui/react";
import { Card } from "@src/components/ui-kit";
import { NavigationBrand } from "@src/components/widgets/AppSubNav/NavigationBrand";

type PageLoadingProps = {
  brandId: string;
};

export const PageLoading = ({ brandId }: PageLoadingProps) => {
  return (
    <Card>
      <Box px="4">
        <NavigationBrand id={brandId} variant="page" />
      </Box>
      <Skeleton minH="50dvh" roundedBottom="xl" />
    </Card>
  );
};
